import { useTranslation } from 'react-i18n-lite'
import { FilterOperator, Operator, Operators } from '../../types'
import FilterActionIcon from './FilterActionIcon'
import { OperatorsList, OperatorsListButton } from './styles'

type ModalOperatorProps = {
  operators: Operators[]
  handleChange?: (operator: Operator) => void
}

export default function ModalOperator({
  operators,
  handleChange
}: ModalOperatorProps) {
  const { t } = useTranslation()

  const renderOperator = (operator: Operators) => {
    if (operator?.operator === FilterOperator.Filteraction) {
      return <FilterActionIcon />
    }

    return operator.des
  }
  return (
    <OperatorsList aria-label={t('operators-list.label')}>
      {operators.map((item, i) => (
        <OperatorsListButton
          type='button'
          key={i}
          onClick={() => handleChange?.(item.operator)}
        >
          {renderOperator(item)}
        </OperatorsListButton>
      ))}
    </OperatorsList>
  )
}
